import { defineStore } from 'pinia'
import { api } from '../utils/axios'

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    messages: [],
    loading: false,
  }),

  getters: {
    count: (state) => state.messages.length,
  },

  actions: {
    async fetch() {
      this.loading = true
      try {
        const response = await api.get('/messages')
        this.messages = response.data
      } catch (error) {
        console.error('Failed to fetch notifications:', error)
      } finally {
        this.loading = false
      }
    },

    async remove(id) {
      try {
        await api.post(`/message/delete/${id}`)
        this.messages = this.messages.filter((m) => m.id !== id)
      } catch (error) {
        console.error('Failed to delete notification:', error)
      }
    },
  },
})
